import {
  useCreateNewVersionMutation,
  useLazyGetSivFollowupLetterQuery,
  useLazySelectSivFollowupLetterQuery,
  usePublishSivFollowupLetterMutation,
  useUpdateSivFollowupLetterMutation
} from 'src/services/SIVFollowupLetterAPI';

export const useSIVFollowupLetter = () => {
  const [
    getSivFollowupLetter,
    {
      data: sivFollowupLetterData,
      isLoading: sivFollowupLetterIsLoading,
      isError: sivFollowupLetterIsError,
      error: sivFollowupLetterError,
      isSuccess: sivFollowupLetterIsSuccess
    }
  ] = useLazyGetSivFollowupLetterQuery();

  const [
    selectSivFollowupLetter,
    {
      data: selectSivFollowupLetterData,
      isLoading: selectSivFollowupLetterIsLoading,
      isError: selectSivFollowupLetterIsError,
      error: selectSivFollowupLetterError,
      isSuccess: selectSivFollowupLetterIsSuccess
    }
  ] = useLazySelectSivFollowupLetterQuery();

  const [
    updateSivFollowupLetter,
    {
      data: updateSivFollowupLetterData,
      isLoading: updateSivFollowupLetterIsLoading,
      isError: updateSivFollowupLetterIsError,
      error: updateSivFollowupLetterError,
      isSuccess: updateSivFollowupLetterIsSuccess
    }
  ] = useUpdateSivFollowupLetterMutation();

  const [
    publishSivFollowupLetter,
    {
      data: publishSivFollowupLetterData,
      isLoading: publishSivFollowupLetterIsLoading,
      isError: publishSivFollowupLetterIsError,
      error: publishSivFollowupLetterError,
      isSuccess: publishSivFollowupLetterIsSuccess
    }
  ] = usePublishSivFollowupLetterMutation();
  const [
    createNewVersion,
    {
      data: createNewVersionData,
      isLoading: createNewVersionIsLoading,
      isError: createNewVersionIsError,
      error: createNewVersionError,
      isSuccess: createNewVersionIsSuccess
    }
  ] = useCreateNewVersionMutation();

  return {
    getSivFollowupLetter,
    sivFollowupLetterData,
    sivFollowupLetterIsLoading,
    sivFollowupLetterIsError,
    sivFollowupLetterError,
    sivFollowupLetterIsSuccess,
    selectSivFollowupLetter,
    selectSivFollowupLetterData,
    selectSivFollowupLetterIsLoading,
    selectSivFollowupLetterIsError,
    selectSivFollowupLetterError,
    selectSivFollowupLetterIsSuccess,
    updateSivFollowupLetter,
    updateSivFollowupLetterData,
    updateSivFollowupLetterIsLoading,
    updateSivFollowupLetterIsError,
    updateSivFollowupLetterError,
    updateSivFollowupLetterIsSuccess,
    publishSivFollowupLetter,
    publishSivFollowupLetterData,
    publishSivFollowupLetterIsLoading,
    publishSivFollowupLetterIsError,
    publishSivFollowupLetterError,
    publishSivFollowupLetterIsSuccess,
    createNewVersion,
    createNewVersionData,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  };
};
